import React, { FC, useEffect, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { UseReCaptcha } from '../../../lib/auth/hooks/useReCaptcha'
import * as Styled from './styled'

export type RegistrationFormReCaptchaProps = Pick<UseReCaptcha, 'reCaptchaProps' | 'captchaError'>

export const RegistrationFormReCaptcha: FC<RegistrationFormReCaptchaProps> = ({
  reCaptchaProps,
  captchaError,
}) => {
  const errorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (captchaError) {
      errorRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [captchaError])

  return (
    <>
      <Styled.RegistrationFormReCaptcha data-cy="registration-form-recaptcha">
        <ReCAPTCHA {...reCaptchaProps} />
      </Styled.RegistrationFormReCaptcha>
      <Styled.ErrorMessage ref={errorRef}>{captchaError}</Styled.ErrorMessage>
    </>
  )
}
